import React from "react";
type KubernetesActionFeedbackCalloutProps = {
    actionTypes?: string[];
};
export function KubernetesActionChameleonMarker({ actionTypes = [] }: KubernetesActionFeedbackCalloutProps) {
    const kubernetesActionTypes = [
        "Octopus.KubernetesRunScript",
        "Octopus.KubernetesDeployService",
        "Octopus.KubernetesDeployIngress",
        "Octopus.KubernetesDeployConfigMap",
        "Octopus.KubernetesDeployContainers",
        "Octopus.KubernetesDeploySecret",
        "Octopus.Kubernetes.Kustomize",
        "Octopus.HelmChartUpgrade",
        "Octopus.KubernetesDeployRawYaml",
    ];
    const hasKubernetesAction = actionTypes.some((actionType) => kubernetesActionTypes.includes(actionType));
    if (hasKubernetesAction) {
        // This is a marker so we can conditionally display surveys/tours in Chameleon
        // See screenshot https://github.com/OctopusDeploy/OctopusDeploy/pull/32573#discussion_r2053078781
        return <div data-chameleon-tour="contains kubernetes action"></div>;
    }
    return null;
}
